export function common() {


  jQuery(function () {

    // タブレット表示
    $(function(){
      var ua = navigator.userAgent;
      var viewport = document.querySelector("meta[name=viewport]");
      if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
          viewport.setAttribute("content", "width=device-width,initial-scale=1");
      } else {
          viewport.setAttribute("content", "width=1030");
      }
    });

    // スマホtel link
    if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
      jQuery(function() {
          $('.tel').each(function() {
              var str = $(this).html();
              if ($(this).children().is('img')) {
                  $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/-/g, '')).append(str + '</a>'));
              } else {
                  $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
              }
          });
      });
    }

    //正確なvhの取得
    /*-
    使い方: calc(var(--vh, 1vh) * 100);
    -*/
    function setHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    setHeight();//初期化
    window.addEventListener('resize', setHeight);// 再計算



    //ブレイクポイント画像切り替え
    var $elem = $('.sp_img');
    var sp = '_sp.';
    var pc = '_pc.';
    var replaceWidth = 767; //ブレイクポイント指定

    function imageSwitch() {
      var windowWidth = parseInt($(window).width()); //ウィンドウサイズ取得
      $elem.each(function () {
          var $this = $(this);
          if (windowWidth >= replaceWidth) {
              $this.attr('src', $this.attr('src').replace(sp, pc));
          } else {
              $this.attr('src', $this.attr('src').replace(pc, sp));
          }
      });
    }
    imageSwitch();

    // リサイズの実行タイミング設定
    var delayStart;
    var delayTime = 200;
    $(window).on('resize', function () {
    clearTimeout(delayStart);
      delayStart = setTimeout(function () {
        imageSwitch();
      }, delayTime);
    });


    //ヘッダーの高さに連動
    function headerHeightSwitch() {
      var headerHeight = jQuery('.l-header').outerHeight(); //ウィンドウサイズ取得
      var wpBreadcrumbHeight = jQuery('.u-wpBreadcrumb').outerHeight(); //ウィンドウサイズ取得
      //jQuery('.c-pageHero_img').css({'top': wpBreadcrumbHeight});
      jQuery('.l-main_inner').css({'padding-top': headerHeight});
      jQuery('.anchor').css({'padding-top': headerHeight});
      jQuery('.anchor').css({'margin-top': -headerHeight});
    }
    headerHeightSwitch();
    jQuery(window).on('resize', function () {
      headerHeightSwitch();
    });


    //navi PC
    if (window.matchMedia('(min-width: 1251px)').matches) {
      jQuery(function ($) {
          $('ul.menu li.menu-item').hover(function() {
              $(this).find('.sub-menu').stop().slideDown();
          }, function() {
              $(this).find('.sub-menu').stop().slideUp();
          });
      })
    }

    //navi sp
    if (window.matchMedia('(max-width: 1250px)').matches) {
       // 親メニュー処理
       $('.menu-item-has-children').click(function() {
         $(this).toggleClass('menu_open');
         // メニュー表示/非表示
         $(this).next('.sub-menu').slideToggle();
       });
       // 子メニュー処理
       $('.menu-item-has-children').click(function(e) {
           // メニュー表示/非表示
           $(this).children('.sub-menu').slideToggle();
           e.stopPropagation();
       });
    }

    //navi SP
    jQuery(function () {
      //bodyのスクロール位置の格納
      var state = false;
      var scrollpos;
      $('#toggle').click(function(){
          if($(this).hasClass('active')){
              $(this).removeClass('active');
              $('.l-header').removeClass('active');
              $('.l-header_navArea').fadeOut();
          }else{
              $(this).addClass('active');
              $('.l-header').addClass('active');
              $('.l-header_navArea').fadeIn().css({'display':'flex'});
          }
          if(state == false) {
            scrollpos = $(window).scrollTop()
            $('body').addClass('fixed').css({'top': -scrollpos})
            state = true;
          } else {
              $('body').removeClass('fixed').css({'top': 0}),
              window.scrollTo( 0 , scrollpos )
              state = false;
          }
      });
      $('.menu-item > a').click(function() {
          if($('.l-header').hasClass('active')){
              $('.l-header_navArea').fadeOut();
              $('.l-header').removeClass('active');
              $('#toggle').removeClass('active');
              if(state == false) {
                scrollpos = $(window).scrollTop()
                $('body').addClass('fixed').css({'top': -scrollpos})
                state = true;
              } else {
                  $('body').removeClass('fixed').css({'top': 0}),
                  window.scrollTo( 0 , scrollpos )
                  state = false;
              }
          }
      });
      $('.nav_close').click(function() {
          if($('.l-header').hasClass('active')){
              $('.l-header_navArea').fadeOut();
              $('.l-header').removeClass('active');
              $('#toggle').removeClass('active');
              if(state == false) {
                  scrollpos = $(window).scrollTop()
                  $('body').addClass('fixed').css({'top': -scrollpos})
                  state = true;
              } else {
                  $('body').removeClass('fixed').css({'top': 0}),
                  window.scrollTo( 0 , scrollpos )
                  state = false;
              }
          }
      });
    });

    //scroll_header
    var startPos = 0,winScrollTop = 0;
    var headerHight = $('.l-header_inner').outerHeight();
    jQuery(window).on('scroll',function(){
        winScrollTop = $(this).scrollTop();
        if (jQuery(this).scrollTop() > headerHight) {
          if (winScrollTop >= startPos) {
            jQuery('.scroll_header').addClass('hide').css({top: -headerHight});
          } else {
            jQuery('.scroll_header').removeClass('hide').css({top: 0});
          }
          startPos = winScrollTop;
      }
    });


    //js-scroll
    var wH = $(window).height();
    var EffectH = wH/5*1;
    jQuery(window).on('scroll load', function() {
      var scTop = $(this).scrollTop();
      var scBottom = scTop + $(this).height();
      var effectPos = scBottom - EffectH;
      jQuery('.js-scroll, .js-scroll-delay').each( function() {
        var thisPos = $(this).offset().top;
        if ( thisPos < effectPos ) {
          $.when(
            jQuery(this).addClass("show")
          ).done(function() {
            jQuery(this).delay(250).queue(function(){
                jQuery(this).addClass("done")
            })
          });
        }
      });
    });

    
    if (window.matchMedia('(max-width: 767px)').matches) {
      const indexHero = document.querySelector('.p-indexHero');
      if(indexHero){
        $(window).on('load resize', function () {
          var WH = document.documentElement.clientHeight;
          var hero = $('.p-indexHero');
          var newsH = $('.p-indexNews').outerHeight();
          var headerH = $('.l-header').outerHeight();
          hero.css({'height': WH - newsH - headerH});
        });
      }
    }
    
    const tickerRoll = document.querySelector('#ticker-roll');
      if(tickerRoll){
        $.simpleTicker($("#ticker-roll"),{'effectType':'roll'});
      }

    $(window).on('load', function () {
      //spanタグを追加する
      var element = $(".c-splitText");
      element.each(function () {
        var text = $(this).text();
        var textbox = "";
        text.split('').forEach(function (t, i) {
          if (t !== " ") {
            if (i < 10) {
              //textbox += '<span class="char" style="animation-delay:.' + i + 's;">' + t + '</span>';
              textbox += '<span class="char" style="opacity:0;">' + t + '</span>';
            } else {
              var n = i / 10;
              //textbox += '<span class="char" style="animation-delay:' + n + 's;">' + t + '</span>';
              textbox += '<span class="char" style="opacity:0;">' + t + '</span>';
            }
          } else {
            textbox += t;
          }
        });
        $(this).html(textbox);
      });
    });


    //js-guideFloat
    jQuery(function() {
      const guideFloat = document.querySelector('.js-guideFloat');
      if(guideFloat){
        var objWrap = $('.js-guideFloat');
        var obj = $('.js-guideFloat .c-pageGuide');
        var scroll;
        var winH = $(window).height();
        var objH = obj.outerHeight();
        var objTop = objWrap.offset().top;
        var objBottom = objTop + objH;

        objWrap.css({'height': objH});
        obj.css({'position': 'fixed','left': '0','bottom': '0'});

        $(window).on('scroll', function(){
          scroll = $(window).scrollTop();
          if (scroll >= 500) {
            objWrap.addClass("is-visible");
          }else{
              objWrap.removeClass("is-visible");
          }
          if(scroll >= objBottom - winH){
            objWrap.removeClass("fixed");
            obj.css({'position': 'relative','left': '0','bottom': '0'});
          }else{
            objWrap.addClass("fixed");
            obj.css({'position': 'fixed','left': '0','bottom': '0'});
          }
          
        });
      }
    });

    const indexHeroSlide = document.querySelector('.p-indexHero_logo_item_main_slide');
    if(indexHeroSlide){
      jQuery(".p-indexHero_logo_item_main_slide").slick({
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 3500,
        adaptiveHeight:true,
        fade: true,
        dots: false,
        arrows: false,
      });
    }

    const pageCase = document.querySelector('.c-pageCase');
    if(pageCase){
      if (window.matchMedia('(max-width: 767px)').matches) {
        jQuery(".c-pageCase").slick({
          autoplay: false,
          adaptiveHeight:true,
          fade: false,
          dots: true,
          arrows: true,
        });
      }
    }


    const modal_department_slide = document.querySelector('.modal_department_slide');
    if(modal_department_slide){
      var flag = false; //モーダル表示1回目か判断するフラグ

      //====slick.jsの設定====
      function slick_setting(){
          $('.modal_department_slide').slick({
              arrows:true, //メイン画像の矢印表示
              prevArrow:'<button class="slick-prev slick-arrow"></button>',
              nextArrow:'<button class="slick-next slick-arrow"></button>',
          });
      }

      //====メイン画面のクリック設定====
      $('.modal-syncer').click(function() {
          var slideNum = $(this).attr('data-slide');
          $('#modal-overlay').show(); //モーダル表示
          if(flag==false){
              slick_setting(); //モーダル表示の１回目だけ実施
              flag=true;
          }
          //var index = $(this).index(); //クリックされた画像番号
          $('.modal_department_slide').slick('slickGoTo', slideNum);//メイン画像の切替
      });

      //====閉じるボタンの設定====
      $('.modal-close').click(function() {
          $('#modal-overlay').hide();
      });

      //====wrapperの外側がクリックされた時====
      $('#modal-overlay').click(function(event) {
        if(!$(event.target).closest('.modal-content').length) {
          $('#modal-overlay').hide();
        }
      });
    }







    

    //ページトップ
    var pageTop = $('#pageTop');
    pageTop.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 650) {
        pageTop.fadeIn();
      } else {
        pageTop.fadeOut();
      }
    });
    pageTop.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 550);
      return false;
    });

    //スムーススクロール
    $('a[href^="#"]').click(function () {
      var speed = 550;
      var href = $(this).attr("href");
      //var headerHight = $('.l-header_inner').outerHeight();
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({ scrollTop: position }, speed, "swing");
      return false;
    });


    //////mwwpform 同意ボタン checkbox制御
    jQuery(function() {
      /* ページ読み込み時のボタン制御処理 */
      if ($('input[id="agreement_01"]:checked').val() && $('input[id="agreement_02"]:checked').val()) {
          $('[name="submitConfirm"]').prop("disabled", false);
      } else {
          $('[name="submitConfirm"]').prop("disabled", true);
      }

      /* 同意のチェックボックスをクリックした際のボタン制御処理 */
      $('[id="agreement_01"]').click(function() {
          if ($('input[id="agreement_01"]:checked').val() && $('input[id="agreement_02"]:checked').val()) {
              $('[name="submitConfirm"]').prop("disabled", false);
          } else {
              $('[name="submitConfirm"]').prop("disabled", true);
          }
      });
      $('[id="agreement_02"]').click(function() {
          if ($('input[id="agreement_02"]:checked').val() && $('input[id="agreement_02"]:checked').val()) {
              $('[name="submitConfirm"]').prop("disabled", false);
          } else {
              $('[name="submitConfirm"]').prop("disabled", true);
          }
      });
    });
    
  });//jQuery

  const aboutNavLink = document.querySelectorAll('.js-current a');
  aboutNavLink.forEach((targetLink) => {
    if (targetLink.href === location.href) {
      targetLink.parentElement.classList.add('is-current');
    }
  });

  const businessNavLink = document.querySelectorAll('.c-pageGuide_list a');
  businessNavLink.forEach((targetLink) => {
    if (targetLink.href === location.href) {
      targetLink.classList.add('is-current');
    }
  });

}
